<template>
  <div class="help-page">
    <!-- Hero Banner -->
    <div class="hero-section">
      <img class="hero-bg" v-lazy="require('@/assets/help/hero-bg-11529d.png')" alt="" />
      <div class="hero-content">
        <div class="hero-text-box">
          <h1 class="hero-title">客户与支持服务</h1>
          <p class="hero-subtitle">为商户提供稳定、安全、持续的技术支持服务</p>
        </div>
        <div class="hero-btn" @click="scrollToContact">联系客服</div>
        <div class="hero-features">
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>7x12小时响应</span>
          </div>
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>专业技术团队</span>
          </div>
          <div class="feature-item">
            <img class="feature-icon" v-lazy="require('@/assets/help/hero-check-icon.svg')" alt="" />
            <span>全流程售后保障</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 我的服务能力 -->
    <div class="section service-section">
      <div class="section-header">
        <h2 class="section-title">我们的服务能力</h2>
        <p class="section-desc">提供多场景解决方案，满足各行业客户的业务需求，快速实现数字化转型</p>
      </div>
      <div class="service-cards">
        <div class="service-card" v-for="item in serviceList" :key="item.title">
          <img class="service-icon" v-lazy="item.icon" alt="" />
          <div class="service-info">
            <h3 class="service-title">{{ item.title }}</h3>
            <p class="service-desc" v-html="item.desc"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 多种支持方式 -->
    <div class="section support-section">
      <div class="section-header">
        <h2 class="section-title">多种支持方式，快速为您解决问题</h2>
      </div>
      <div class="support-cards">
        <div class="support-card wechat-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-wechat.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title green">在线客服</h3>
            <p class="support-desc">实时在线沟通，快速响应<br />微信/企微客服，方便快捷</p>
            <div class="support-btn green-btn" @click="scrollToPresale">立即咨询</div>
          </div>
        </div>
        <div class="support-card ticket-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-ticket.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title purple">提交工单</h3>
            <p class="support-desc">详细描述问题，专人跟进<br />问题跟踪处理，进度可查</p>
            <span class="support-tag purple-tag">代理商专属通道</span>
          </div>
        </div>
        <div class="support-card phone-card">
          <img class="support-icon" v-lazy="require('@/assets/help/icon-phone-support.svg')" alt="" />
          <div class="support-info">
            <h3 class="support-title blue">电话支持</h3>
            <p class="support-desc">电话一对一服务，专业高效<br />工作时间：9:00 - 21:00</p>
            <span class="support-tag blue-tag">400-086-1123</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 服务流程 -->
    <div class="section flow-section">
      <div class="section-header">
        <h2 class="section-title">服务流程</h2>
      </div>
      <div class="flow-steps">
        <template v-for="(step, index) in flowSteps">
          <div class="flow-step" :key="step.num">
            <img class="step-icon" v-lazy="step.icon" alt="" />
            <h3 class="step-title">{{ step.title }}</h3>
            <p class="step-desc" v-html="step.desc"></p>
          </div>
          <img
            v-if="index < flowSteps.length - 1"
            :key="'arrow-' + step.num"
            class="step-arrow"
            v-lazy="require('@/assets/help/step-arrow.png')"
            alt=""
          />
        </template>
      </div>
    </div>

    <!-- 服务保障 -->
    <div class="section guarantee-section">
      <div class="section-header">
        <h2 class="section-title">服务保障</h2>
        <p class="section-desc">数十年的行业服务经营，做商家服务领域最值得信赖的伙伴</p>
      </div>
      <div class="guarantee-cards">
        <div class="guarantee-card" v-for="item in guaranteeList" :key="item.value">
          <img class="guarantee-icon" v-lazy="item.icon" alt="" />
          <div class="guarantee-info">
            <div class="guarantee-value">{{ item.value }}</div>
            <div class="guarantee-label">{{ item.label }}</div>
            <p class="guarantee-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 仍有疑问 -->
    <div class="section question-section" ref="presaleSection">
      <div class="question-inner">
        <h2 class="question-title">仍有疑问？</h2>
        <p class="question-subtitle">您可以通过以下方式联系我们</p>
        <div class="question-cards">
          <div class="question-card ticket-question">
            <img class="question-bg-icon" v-lazy="require('@/assets/help/icon-question-ticket.svg')" alt="" />
            <div class="question-content">
              <div class="question-intro">
                <h3 class="q-intro-title">工单咨询</h3>
                <p class="q-intro-desc">产品使用问题及技术支持</p>
              </div>
              <p class="q-intro-time">提交工单·五个工作日内回复</p>
            </div>
            <div class="question-btn">
              <span>仅代理商开放</span>
            </div>
          </div>
          <div class="question-card presale-question">
            <img class="question-bg-icon" v-lazy="require('@/assets/help/icon-question-presale.svg')" alt="" />
            <div class="question-content">
              <div class="question-intro">
                <h3 class="q-intro-title">售前咨询</h3>
                <p class="q-intro-desc">付费咨询及解决方案</p>
              </div>
              <p class="q-intro-time">微信扫码：周一至周日 9：00-20：00 回复</p>
            </div>
            <img class="presale-qr" v-lazy="require('@/assets/help/qr-code.png')" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PcHelp",
  data() {
    return {
      serviceList: [
        {
          icon: require("@/assets/help/icon-service.svg"),
          title: "专业客服支持",
          desc: "专业客服团队，快速响应商户问题<br />多渠道接入，7x12小时在线服务",
        },
        {
          icon: require("@/assets/help/icon-maintain.svg"),
          title: "技术运维服务",
          desc: "系统实施监控，保障稳定运行<br />专业运维团队，快速定位解决问题",
        },
        {
          icon: require("@/assets/help/icon-upgrade.svg"),
          title: "系统升级维护",
          desc: "持续功能更新，强化产品体验<br />定期系统维护，确保最佳性能",
        },
        {
          icon: require("@/assets/help/icon-security.svg"),
          title: "安全保障",
          desc: "多维安全防护，保障数据安全<br />严格权限管理，保护商户隐私",
        },
      ],
      flowSteps: [
        {
          num: "01",
          icon: require("@/assets/help/step-icon-01.png"),
          title: "提交问题",
          desc: "描述问题发生过程<br />提交问题",
        },
        {
          num: "02",
          icon: require("@/assets/help/step-icon-02.png"),
          title: "技术受理",
          desc: "技术团队受理<br />确认问题信息",
        },
        {
          num: "03",
          icon: require("@/assets/help/step-icon-03.png"),
          title: "问题分析",
          desc: "分析问题原因<br />制定解决方案",
        },
        {
          num: "04",
          icon: require("@/assets/help/step-icon-04.png"),
          title: "解决处理",
          desc: "实施解决方案<br />处理问题",
        },
        {
          num: "05",
          icon: require("@/assets/help/step-icon-05.png"),
          title: "反馈结果",
          desc: "确认问题解决<br />收集反馈意见",
        },
      ],
      guaranteeList: [
        {
          icon: require("@/assets/help/icon-guarantee-stable.svg"),
          value: "99.99%",
          label: "系统稳定性",
          desc: "高可用架构保障系统稳定运行",
        },
        {
          icon: require("@/assets/help/icon-guarantee-exp.svg"),
          value: "10000+",
          label: "商户服务经验",
          desc: "为1w+商户提供优质服务",
        },
        {
          icon: require("@/assets/help/icon-guarantee-hour.svg"),
          value: "7x12",
          label: "小时支持",
          desc: "每天9:00-21:00专业技术支持",
        },
        {
          icon: require("@/assets/help/icon-guarantee-response.svg"),
          value: "<3min",
          label: "平均响应时间",
          desc: "快速响应，及时解决问题",
        },
      ],
    };
  },
  methods: {
    scrollToContact() {
      this.$refs.presaleSection.scrollIntoView({ behavior: "smooth" });
    },
    scrollToPresale() {
      this.$refs.presaleSection.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style lang="less" scoped>
.help-page {
  width: 100%;
  min-width: 1420px;
  position: relative;
}

/* Hero Section */
.hero-section {
  position: relative;
  width: 100%;
  height: 560px;
  overflow: hidden;

  .hero-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hero-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 280px;
    box-sizing: border-box;
  }

  .hero-text-box {
    margin-bottom: 24px;
  }

  .hero-title {
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
    font-weight: 700;
    font-size: 56px;
    line-height: 64px;
    color: #04154a;
    margin: 0 0 16px;
  }

  .hero-subtitle {
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    color: #69717e;
    margin: 0;
  }

  .hero-btn {
    width: fit-content;
    height: 48px;
    background: #336fff;
    border-radius: 6px;
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
    font-size: 20px;
    color: #fff;
    padding: 0 42px;
    line-height: 48px;
    box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
    cursor: pointer;
    margin-bottom: 24px;

    &:hover {
      background: #2960e6;
    }
  }

  .hero-features {
    display: flex;
    gap: 40px;
    margin-top: 24px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: "Noto Sans SC", sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    color: #002864;

    .feature-icon {
      width: 24px;
      height: 24px;
    }
  }
}

/* Common Section */
.section {
  padding: 64px 0;

  .section-header {
    text-align: center;
    margin-bottom: 40px;
  }

  .section-title {
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
    font-weight: 500;
    font-size: 30px;
    line-height: 48px;
    color: #04154a;
    margin: 0 0 12px;
  }

  .section-desc {
    font-family: "Source Han Sans CN", "Microsoft YaHei", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3d485d;
    margin: 0;
  }
}

/* Service Section */
.service-section {
  background: #f7fafe;

  .service-cards {
    width: 1420px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
  }

  .service-card {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
    display: flex;
    gap: 16px;

    .service-icon {
      width: 80px;
      height: 80px;
      border-radius: 80px;
      flex-shrink: 0;
    }

    .service-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .service-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 700;
      font-size: 22px;
      line-height: 30px;
      color: #202d40;
      margin: 0;
    }

    .service-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #3d485d;
      margin: 0;
    }
  }
}

/* Support Section */
.support-section {
  background: #f7fafe;

  .support-cards {
    width: 1420px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
  }

  .support-card {
    flex: 1;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
    display: flex;
    gap: 16px;

    .support-icon {
      width: 80px;
      height: 80px;
      border-radius: 80px;
      flex-shrink: 0;
    }

    .support-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .support-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 700;
      font-size: 22px;
      line-height: 30px;
      margin: 0;

      &.green {
        color: #09bb07;
      }
      &.purple {
        color: #907fff;
      }
      &.blue {
        color: #336fff;
      }
    }

    .support-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #3d485d;
      margin: 0;
    }

    .support-btn {
      width: fit-content;
      height: 36px;
      border-radius: 6px;
      font-family: "Noto Sans SC", sans-serif;
      font-size: 16px;
      padding: 0 16px;
      line-height: 36px;
      cursor: pointer;
      &.green-btn {
        background: rgba(9, 187, 7, 0.1);
        border: 1px solid #09bb07;
        color: #09bb07;

        &:hover {
          background: rgba(9, 187, 7, 0.2);
        }
      }
    }

    .support-tag {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;

      &.purple-tag {
        color: #907fff;
      }
      &.blue-tag {
        color: #336fff;
      }
    }
  }

  .wechat-card {
    background: #eaf9f7;
  }

  .ticket-card {
    background: #f7f2ff;
  }

  .phone-card {
    background: #e6f1ff;
  }
}

/* Flow Section */
.flow-section {
  background: #f7fafe;

  .flow-steps {
    width: 1420px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .flow-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 200px;
    flex-shrink: 0;

    .step-icon {
      width: 120px;
      height: 64px;
      flex-shrink: 0;
    }

    .step-title {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 700;
      font-size: 22px;
      line-height: 30px;
      color: #202d40;
      margin: 0;
    }

    .step-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #3d485d;
      margin: 0;
      text-align: center;
    }
  }

  .step-arrow {
    width: 80px;
    height: 64px;
    margin-top: 0;
    flex-shrink: 0;
    object-fit: contain;
    object-position: center;
  }
}

/* Guarantee Section */
.guarantee-section {
  background: #f7fafe;

  .guarantee-cards {
    width: 1420px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
  }

  .guarantee-card {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0px 5px 9px rgba(52, 94, 184, 0.1);
    display: flex;
    gap: 16px;

    .guarantee-icon {
      width: 64px;
      height: 64px;
      border-radius: 80px;
      flex-shrink: 0;
    }

    .guarantee-info {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .guarantee-value {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 700;
      font-size: 32px;
      line-height: 40px;
      color: #336fff;
    }

    .guarantee-label {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 700;
      font-size: 22px;
      line-height: 30px;
      color: #202d40;
    }

    .guarantee-desc {
      font-family: "Noto Sans SC", sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 30px;
      color: #3d485d;
      margin: 0;
    }
  }
}

/* Question Section */
.question-section {
  background: #f7fafe;

  .question-inner {
    width: 1420px;
    margin: 0 auto;
    text-align: center;
  }

  .question-title {
    font-family: "Microsoft YaHei", sans-serif;
    font-weight: 400;
    font-size: 32px;
    line-height: 42px;
    color: #333333;
    margin: 0 0 10px;
  }

  .question-subtitle {
    font-family: "Microsoft YaHei", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    color: #626e81;
    margin: 0;
  }

  .question-cards {
    display: flex;
    gap: 50px;
    margin-top: 40px;
  }

  .question-card {
    flex: 1;
    height: 144px;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
    padding: 22px 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .question-bg-icon {
      position: absolute;
      opacity: 0.3;
      pointer-events: none;
    }

    .question-content {
      display: flex;
      flex-direction: column;
      gap: 20px;
      z-index: 1;

      .question-intro {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .q-intro-title {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
        color: #fff;
        margin: 0;
      }

      .q-intro-desc {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #fff;
        margin: 0;
      }

      .q-intro-time {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #fff;
        margin: 0;
      }
    }

    .question-btn {
      position: absolute;
      right: 40px;
      bottom: 49px;
      background: #fff;
      border-radius: 6px;
      padding: 10px;
      z-index: 1;

      span {
        font-family: "Noto Sans SC", sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #626e81;
        white-space: nowrap;
      }
    }

    .presale-qr {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 100px;
      height: 100px;
      z-index: 1;
    }
  }

  .ticket-question {
    background: linear-gradient(90deg, #f78c9a 0%, #f9748f 19%, #fd868c 60%);

    .question-bg-icon {
      left: -44px;
      top: 29px;
      width: 156px;
      height: 156px;
    }
  }

  .presale-question {
    background: linear-gradient(90deg, #0c3483 0%, #a2b6df 100%, #6b8cce 100%);

    .question-bg-icon {
      left: -5px;
      top: 48px;
      width: 109px;
      height: 109px;
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/help.vue